import { render, staticRenderFns } from "./CreateDepositModal.vue?vue&type=template&id=e95a0024&"
import script from "./CreateDepositModal.vue?vue&type=script&lang=js&"
export * from "./CreateDepositModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports